// extracted by mini-css-extract-plugin
export default {"link":"EmailLink_link__35wC-"};